<script>
  import _ from 'underscore'
  import Item from './Item.vue'

  export default {
    components: { Item },
    props: {
      title: String,
      color: String,
      items: Array,
      isOrphan: Boolean,
    },

    data () {
      return {
      }
    },

    computed: {
    },

    watch: {
    },

    created () {
    },

    mounted () {
    },

    beforeDestroy () {
    },

    methods: {
      getItemById (id = '') {
        return _.findWhere(this.items, { id }) || null
      },

      arrangeItemData (item = {}) {
        const itemForStatus = this.getItemById(item.aggregation) || item
        const { numOwned, numReleased, isProcured, isRecruiting, unnecessary } = itemForStatus
        return Object.assign({}, item, { numOwned, numReleased, isProcured, isRecruiting, unnecessary })
      },

      replaceVL2BR (str = '') {
        return _.escape(str).split('|').join('<br>')
      },
    },

    filters: {
    },
  }
</script>


<template>
  <section class="ItemList" :class="{ '-isOrphan': isOrphan, '-hasNoTitle': !title }" v-if="!!items.length">
    <h2 v-if="title" class="ItemList__title" :style="{ color }" v-html="replaceVL2BR(title)"></h2>
    <div class="ItemList__body">
      <Item v-for="item in items" v-bind="arrangeItemData(item)" :key="item.id" :bgcolor="color" />
    </div>
  </section>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  .ItemList {
    & {
      display: block;
      margin: 0;
      padding: 0;
      text-align: left;

      &:not(:first-child) {
        margin-top: $size-unit * 10;
      }
      &:not(:last-child) {
        margin-bottom: $size-unit * 10;
      }
    }

    &__title {
      display: block;
      margin: 0 0 0 4px;
      padding: 0;
      font-family: $font-family--fancy;
      font-size: $size-unit * 7;
      filter: saturate(1.25);
      text-shadow:  0px  4px 1px #fff,
                    1px  4px 1px #fff,
                    2px  4px 1px #fff,
                    3px  3px 1px #fff,
                    4px  2px 1px #fff,
                    4px  1px 1px #fff,
                    4px  0px 1px #fff,
                    4px -1px 1px #fff,
                    4px -2px 1px #fff,
                    3px -3px 1px #fff,
                    2px -4px 1px #fff,
                    1px -4px 1px #fff,
                    0px -4px 1px #fff,
                   -1px -4px 1px #fff,
                   -2px -4px 1px #fff,
                   -3px -3px 1px #fff,
                   -4px -2px 1px #fff,
                   -4px -1px 1px #fff,
                   -4px  0px 1px #fff,
                   -4px  1px 1px #fff,
                   -4px  2px 1px #fff,
                   -3px  3px 1px #fff,
                   -2px  4px 1px #fff,
                   -1px  4px 1px #fff,
                    0px  4px 1px #fff;
    }

    &__body {
      display: flex;
      justify-content: flex-start;
      flex-direction: row;
      flex-wrap: wrap;
      margin: ($size-unit * 1) 0 0;
      padding: 0;
      padding-bottom: $item-padding;  // 内部の Item が持つ $item-padding 分の負値マージン相殺
    }

    // 「タイトル指定なし」を意味する modifier
    &.-hasNoTitle:not(:first-child) {
      margin-top: 0 - ($size-unit * 10);
    }

    // 「カラムをまたいで別れている LtemList の残り分」を意味する modifier
    // スマホの時に。別れている LtemList をひと続きに見えるようにする
    @include iroha-vw-range($to: strip-unit($device-width--tab)) {
      &.-isOrphan {
        margin-top: 0 - ($size-unit * 11);
      }
      &.-isOrphan &__title {
        display: none;
      }
    }
  }
</style>
